jQuery(document).ready(function() {
  console.log('new document ready');

    console.log(jQuery('.product-form__input input[type="radio"]:checked').val().toLowerCase());
  
    if(jQuery('.product-form__input input[type="radio"]:checked').val().toLowerCase().includes('tester')){
      jQuery('#testerText').show();
    }else if(jQuery('.product-form__input input[type="radio"]:checked').val().toLowerCase().includes('8ml travel spray')){
      jQuery('#travelSpray').show();
    }
  
    // Check for changes in the radio button selection
    jQuery('.product-form__input label').on('click',function() {
      console.log(jQuery(this).text().toLowerCase(), jQuery(this).text().toLowerCase().includes('tester'));
        if (jQuery(this).text().toLowerCase().includes('tester')) {
            jQuery('#testerText').css('display','inline-block');
           jQuery('#travelSpray').hide();
          
        } else if(jQuery(this).text().toLowerCase().includes('8ml travel spray')){
           jQuery('#travelSpray').show();
          jQuery('#testerText').hide();
        }else {
            jQuery('#testerText, #travelSpray').hide();
        }
    });

    // Handle click on tester text to show popup
    jQuery('#testerText').click(function() {
        jQuery('.tester-popup').show();
        jQuery('.tester-overlay').show();
    });

    // Close popup when clicking the close button or overlay
    jQuery('#close, .tester-overlay').click(function() {
        jQuery('.tester-popup').hide();
        jQuery('.tester-overlay').hide();
    });

  
  
});

 

// document.addEventListener('DOMContentLoaded', function() {
//   var variantId = '41787659649083';
//   function removeCartItemsWithVariant(variantId) {
//   $('.cart-item__link').each(function() {
//       // Check if the href attribute contains the variant ID
//       if ($(this).attr('href').includes(variantId)) {
//         // Find the parent element with the class 'cart-item' and remove it from the DOM
//         $(this).closest('.cart-item').remove();
//         console.log('Removed cart item with variant ID:', variantId);
//       }
//     });

//   }

//   removeCartItemsWithVariant(variantId);
//   checkInsurance();
//   checkIfCartHasOnlyVariant(variantId);
  
//   function addToCartIfNotExists(variantId) {
//   $.ajax({
//     type: 'GET',
//     url: '/cart.js',
//     dataType: 'json',
//     success: function(cart) {
//       var itemExists = cart.items.some(function(item) {
//         return item.id == variantId;
//       });

//       if (!itemExists) {
//         $.ajax({
//           type: 'POST',
//           url: '/cart/add.js',
//           data: {
//             quantity: 1,
//             id: variantId
//           },
//           dataType: 'json',
//           success: function(data) {
//             // Update the cart count
//             console.log('Item added to cart. Current item count: ' + data.item_count);
//             removeCartItemsWithVariant(variantId);
//             checkIfCartHasOnlyVariant()
//           },
//           error: function(xhr, status, error) {
//             console.error('Error adding item to cart:', error);
//           }
//         });
//       } else {
//         console.log('Item already in cart.');
//       }
//     },
//     error: function(xhr, status, error) {
//       console.error('Error fetching cart data:', error);
//     }
//   });
    
// }

//   function removeFromCart() {
//   $.ajax({
//     type: 'POST',
//     url: '/cart/change.js',
//     data: {
//       quantity: 0,
//       id: '41787659649083'
//     },
//     dataType: 'json',
//     success: function(data) {
//       // Update the cart count
//       console.log('Item removed from cart. Current item count: ' + data.item_count);
//             removeCartItemsWithVariant(variantId);
      
//     },
//     error: function(xhr, status, error) {
//       console.error('Error removing item from cart:', error);
//     }
//   });
// }

//    function checkIfCartHasOnlyVariant() {
//      console.log('check if only this variant')
//     $.ajax({
//       type: 'GET',
//       url: '/cart.js',
//       dataType: 'json',
//       success: function(cart) {
//         console.log('cart object', cart)
//         if (cart.items.length === 1 && cart.items[0].id == 41787659649083) {
//           console.log('Cart only has the specified item. Removing it.');
//           removeFromCart(variantId);
//         }
//       },
//       error: function(xhr, status, error) {
//         console.error('Error fetching cart data:', error);
//       }
//     });
//   }

//   $(document).on('cart:updated', function() {
//     checkIfCartHasOnlyVariant();
//   });
  
//   function checkInsurance(){
//      var checkboxVal = $('.nvd-toggle-switch input[type="checkbox"]').is(':checked');
//     var productId = '41787659649083';
//     console.log('click test', );
//     console.log(checkboxVal, 'checkboxVal')
//     if(checkboxVal){
//       console.log('remove product');
//       removeFromCart(productId);
//     }else{
//       console.log('add product');
//         addToCartIfNotExists(productId);
//     }
//   }

//   $('.shopify-payment-button').on('mouseenter', checkInsurance)

//   $('.cart__blocks, .cart-notification__links').on('click', checkInsurance) 
  
//   // check cart updates

//    var elemToObserve = document.getElementById('main-cart-items');
//     var prevClassState = elemToObserve.classList.contains('cart__items--disabled');
//     var observer = new MutationObserver(function(mutations) {
//                         mutations.forEach(function(mutation) {
//                             if(mutation.attributeName == "class"){
//                                 var currentClassState = mutation.target.classList.contains('cart__items--disabled');
//                                 if(prevClassState !== currentClassState)    {
//                                     prevClassState = currentClassState;
//                                     if(currentClassState)
//                                         console.log("class added!");
//                                     else
//                                         checkIfCartHasOnlyVariant()
//                                         console.log("class removed!");
//                                 }
//                             }
//                         });
//                     });
//     observer.observe(elemToObserve, {attributes: true});

                            
// });

//FAQS
$(document).ready(function() {
    $(".category").on("click", function() {
        var category = $(this).data("category");

        // Highlight the active category button
        $(".category").removeClass("active");
        $(this).addClass("active");

        // Show the corresponding FAQ section and hide others
        $(".faq-accordion").hide();
        $("#" + category).show();

        // Scroll to the FAQ section
        $('html, body').animate({
            scrollTop: $("#" + category).offset().top - 100
        }, 500);
    });

    // Accordion functionality
    $(".faq-item").on("click", function() {
        $(".faq-item").removeClass('active');
        var panel = $(this).children(".panel");
        if (panel.is(":visible")) {
            panel.slideUp();
            $(this).removeClass('active'); 
        } else {
            $(".panel").slideUp();
            panel.slideDown();
            $(this).addClass('active');
          
        }
    });

    var hashValue = window.location.hash;
    console.log("Hash Value:", hashValue);
    console.log("Hash Value:", $(".faq-item").length > 0);

    function openFirstFAQ(){
      var getFirstCategory = $(".category:first-of-type");
      var categoryName = $(getFirstCategory).data('category');
      var category = ".faq-item[data-category='"+categoryName+"']:first-of-type";
      $(getFirstCategory).addClass('active');
      $("#"+categoryName).show()
      $(category).trigger('click');
    }
    if(hashValue == "" && $(".faq-item").length > 0){
      openFirstFAQ();
    }else{
      var hashFaq = $(hashValue)
      if(hashFaq.length > 0){
        var categoryName = $(hashValue).data('category');
        console.log('category name'+ categoryName);
        var category = ".category[data-category='"+categoryName+"']";
        $("#"+categoryName).show();
        $(category).addClass("active");
        $(hashFaq).trigger('click');
      }else{
        openFirstFAQ();
      }
    }
});

$(document).ready(function() {
  console.log('smooth scroll');
  // Hide alphabet links that don't have collections
  $('.alphabet-link a').each(function() {
    var targetSection = $(this).attr('href');
    if ($(targetSection).length === 0) {
      $(this).parent().hide(); // Hide the link if no collection section exists
    }
  });

  // Smooth scroll to sections when alphabet links are clicked
  $('.alphabet-link a').on('click', function(e) {
    e.preventDefault();
    var target = $(this).attr('href');
    $('html, body').animate({
      scrollTop: $(target).offset().top - 100
    }, 1000);
  });

    $(window).scroll(function() {
    if ($(this).scrollTop() > 200) { // Show the button when the user scrolls down 200px
      $('#scrollToTopBtn').fadeIn();
    } else {
      $('#scrollToTopBtn').fadeOut();
    }
  });

  // Scroll smoothly to the top when the button is clicked
  $('#scrollToTopBtn').on('click', function(e) {
    e.preventDefault();
    $('html, body').animate({
      scrollTop: 0
    }, 1000); // Scroll duration in milliseconds
  });

});
